<template>
  <FlotoCrudContainer
    ref="list"
    as-table
    :fetch-fn="getNetworks"
    :columns="tableColumns"
    :selectable="selectable"
    :max-allowed-selection="maxAllowedSelection"
    @selection-change="$emit('selection-change', $event)"
  >
    <template v-slot:createdBy="{ item }">
      <td class="text-ellipsis">
        <FlotoTechnicianPicker :value="item.createdBy" disabled />
        <small class="text-neutral pl-8">
          {{ item.createdAt | datetime(undefined, true) }}
        </small>
      </td>
    </template>
    <template v-slot:updatedBy="{ item }">
      <td class="text-ellipsis">
        <FlotoTechnicianPicker :value="item.updatedBy" disabled />
        <small class="text-neutral pl-8">
          {{ item.updatedAt | datetime(undefined, true) }}
        </small>
      </td>
    </template>
    <template v-slot:form>
      <span />
    </template>
    <template v-slot="slotData">
      <slot v-bind="slotData"></slot>
    </template>
  </FlotoCrudContainer>
</template>

<script>
import { getNetworkScanApi } from '@modules/asset-management/api/network-scan-api'

export default {
  name: 'NetworkSelectionList',
  props: {
    maxAllowedSelection: {
      type: Number,
      default() {
        return 1
      },
    },
    hasActions: { type: Boolean, default: false },
    selectable: { type: Boolean, default: false },
  },
  data() {
    this.tableColumns = [
      { name: `${this.$t('name')}`, key: 'name' },
      {
        name: `${this.$t('created_by')}`,
        key: 'createdBy',
      },
      ...(this.hasActions
        ? [
            {
              name: this.$tc('action', 2),
              key: 'actions',
              minWidth: '80px',
            },
          ]
        : []),
    ]
    return {}
  },
  methods: {
    getNetworks(limit, offset) {
      return getNetworkScanApi({}, limit, offset)
    },
    refresh() {
      this.$refs.list.refresh()
    },
  },
}
</script>
